export default {
    groupName: 'Tmobile',
    appName: 'T-Mobile',
    baseRoute: '/dashboard/TMobile',
    label: 'Ad Effect Dashboard',
    home: '/slicer',
    image: 'tmobile.png',
    description: 'T-Mobile Ad Effect Dashboard'
};


// WEBPACK FOOTER //
// ./src/app/configuration/Tmobile/config/main.js